module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"gl":{"centertype":"Tipos de Centro:","disable-all":"Desactivar todas","enable-all":"Activar todas"},"es":{"centertype":"Tipos de Centro:","disable-all":"Desactivar todas","enable-all":"Activar todas"}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/filter/FilterTipoCentro.vue
// module id = 120
// module chunks = 0